import { EMPTY_STRING } from '@e-socna/empty';
import { invariant } from '@e-socna/utils';

export const parseStaticNumberInput = (rawValue: string): number | null => {
  if (rawValue === EMPTY_STRING) {
    return null;
  }

  const value = Number(rawValue);

  invariant(!Number.isNaN(value), 'Value must be a number');

  return value;
};
